import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { HttpService } from '../http/http.service';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class PhleboService {
    public phlebodata: any;

    constructor(private httpService: HttpService) { }

    listPhlebo(params: any): Observable<any> {
        const url = `${environment.PhleboApiendpoint}/phlebo-list`;
        return this.httpService.get(url, this.httpService.headers, params)
            .pipe(catchError(this.Errorhandling));
    }

    // savePhlebo(data: any): Observable<any> {
    //   const url = `${environment.baseUrl}/api/order`;
    //   return this.httpService
    //     .post(url, data, this.httpService.headers)
    //     .pipe(catchError(this.Errorhandling));

    // }

    barcodesAndDocument(id:any) {
        const url = `${environment.PhleboApiendpoint}/visitbarcode-listing/${id}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }


    obtainDistanceReports(search: any) {

        const url = `${environment.OrderApiendpoint}/phlebo-distance-report-new?${search}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    exportPhleboDistanceReports(search: any) {

        const url = `${environment.OrderApiendpoint}/phlebo-distance-report-export?${search}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }


    changeLocation(data:any,id){
        const url = `${environment. SettingsApiendpoint}/start-end-point-update/${id}`;
        return this.httpService.put(url,data, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    getallPhlebo() {
        const url = `${environment.SettingsApiendpoint}/get-phlebos/`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    getAllPhleboByCity(city_id: any) {
        // const url = `${environment.SettingsApiendpoint}/get-phlebos?city_id=${city_id}`;
        let url = `${environment.SettingsApiendpoint}/get-phlebos`;
        if (city_id) {
            url += `?city_id=${city_id}`;
        }
        return this.httpService.get(url, this.httpService.headers).pipe(
            catchError(this.Errorhandling)
        );
    }



    obtainTaskGPS(id:any) {
        const url = `${environment.OrderApiendpoint}/phlebo_tracking_new/${id}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    addPhlebo(data: any): Observable<any> {
        const url = `${environment.SettingsApiendpoint}/phlebos`
        return this.httpService.post(url, data, this.httpService.headers)
    }


    deletePhlebo(id: any) {
        const url = `${environment.SettingsApiendpoint}/phlebos/${id}`;
        return this.httpService.delete(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    obtainPhlebo(user: any) {
        const url = `${environment.SettingsApiendpoint}/phlebos/${user}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }
    obtainRosters() {
        const url = `${environment.PhleboApiendpoint}/master_roster`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }
    saveRosters(data:any) {
        const url = `${environment.PhleboApiendpoint}/master_roster`;
        return this.httpService.post(url, data, this.httpService.headers)

    }

    editPhlebo(data: any, phlebo: any): Observable<any> {
        const url = `${environment.SettingsApiendpoint}/phlebos-update/${phlebo}`
        return this.httpService.post(url, data, this.httpService.headers)
    }

    phleboDetails(id: any) {
        const url = `${environment.SettingsApiendpoint}/phleboDetail/${id}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    updateStatus(id: any, status: any): Observable<any> {



        let data ;
        if (status == 'Active') {
            data = {
                status: 'Inactive'
            };
        }else{
            data = {
                status: 'Active'
            };
        }
        const url = `${environment.SettingsApiendpoint}/phlebo-change-status/${id}`;
        return this.httpService.patch(url, data, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    obtainPhlebos(search: any) {
        const url = `${environment.SettingsApiendpoint}/phlebos?${search}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    getAllCityById(id: any) {
        console.log('getAllCityById', id);

        const url = `${environment.SettingsApiendpoint}/cities-by-state-id/${id}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    getGoogleLatLong(id: any) {
        const url = `${environment.PhleboApiendpoint}/geocode?address=${id}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    getAllCity() {
        const url = `${environment.SettingsApiendpoint}/cities?d=all`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    getAllAreacodeById(id: any) {
        const url = `${environment.SettingsApiendpoint}/area-codes-by-city-id/${id}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }
    getAllAreacodeByCityIds(cityIds: number[]) {
        const queryParam = encodeURIComponent(JSON.stringify(cityIds));
        const url = `${environment.SettingsApiendpoint}/area-codes-by-city-ids?city_ids=${queryParam}`;

        return this.httpService.get(url, this.httpService.headers)
          .pipe(
            catchError(this.Errorhandling)
          );
      }

    // getAllAreacodeByCityIds(cityIds: number[]) {
    //     const queryParam = encodeURIComponent(JSON.stringify(cityIds));
    //     const url = `${environment.SettingsApiendpoint}/area-codes-by-city-ids?city_ids=${queryParam}`;

    //     return this.httpService.get(url, this.httpService.headers)
    //         .pipe(
    //             catchError(this.Errorhandling)
    //         );
    // }

    onSaveRoster(data: any,phlebo_id:any): Observable<any> {
        const url = `${environment.SettingsApiendpoint }/add_roster/${phlebo_id}`
        return this.httpService.post(url, data, this.httpService.headers)
    }
    getRunnerByclientId(id: any) {
        const url = `${environment.SettingsApiendpoint}/phlebo_roster_list/${id}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }


    // <------------------------------------phlebos leaves------------------------------------------>
    updateLeave(data: any, id: any): Observable<any> {
        const url = `${environment.SettingsApiendpoint}/updateLeave/${id}`
        return this.httpService.put(url, data, this.httpService.headers)
    }
    createLeave(data: any): Observable<any> {
        const url = `${environment.SettingsApiendpoint}/addLeaves`;
        return this.httpService.post(url, data, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }
    getallLeave(data: any) {
        const url = `${environment.SettingsApiendpoint}/leaveList?${data}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }
    deleteLeave(id: any) {
        const url = `${environment.SettingsApiendpoint}/deleteList/${id}`;
        return this.httpService.delete(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    updateLeaveStatus(id: any, status: any) {
        const url = `${environment.SettingsApiendpoint}/changeStatus/${id}`;
        return this.httpService.put(url,status, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    getPhlebo(data: any): Observable<any> {
        this.phlebodata = [
            {
                id: '1',
                emp_code: '123',
                first_name: 'Abhishek',
                last_name: 'Anand',
                email: 'temp@email.com',
                phone: '25012021',
                status: 'Active',
                city: 'Dehradun',
                state: 'Uttarakhand',
            },
        ];

        return this.phlebodata;
    }
    Errorhandling(err: HttpErrorResponse) {
        if (err.error instanceof ErrorEvent) {
            console.error(err.error.message);
        } else {
            console.error(`Backend returned code ${err.status}`);
        }
        return throwError('Please try again later.');
    }
}
